import { useState } from 'react';
import downIcon from 'src/icons/down.svg';
import exclamationIcon from 'src/icons/exclamation.svg';

import './SelectDropdown.css';

const SelectDropdown = ({
    label,
    text,
    placeholder,
    showPlaceholder,
    className = '',
    dropdownContainerClassName = '',
    color = '',
    contentClassName = '',
    icon,
    error,
    children,
}) => {
    const [open, setOpen] = useState();

    return (
        <label className={className}>
            {label}
            <div className="relative mt-2">
                <button
                    className={`select-dropdown flex w-full justify-between items-center text-sm ${
                        !dropdownContainerClassName.includes('bg-') && 'bg-gray-light'
                    } py-2 px-5 rounded-xl outline-none focus:ring-orange focus:border-orange h-11 ${
                        error ? 'border border-red' : ''
                    } ${dropdownContainerClassName}`}
                    onClick={(e) => {
                        if (
                            !e.target.className.includes('select-dropdown') &&
                            !e.target.className.includes('select-dropdown-text') &&
                            !e.target.className.includes('select-dropdown-icon')
                        ) {
                            return;
                        }
                        setOpen(!open);
                    }}
                    type="button"
                >
                    {showPlaceholder ? (
                        <span className={`text-gray-darker select-dropdown-text ${color}`}>{placeholder}</span>
                    ) : (
                        <span className={`select-dropdown-text ${color}`}>{text}</span>
                    )}
                    {icon ?? (
                        <img
                            src={downIcon}
                            alt="down arrow"
                            className={(open ? 'rotate-180' : '') + ' select-dropdown-icon'}
                        />
                    )}
                </button>
                {open && (
                    <div
                        className={'select-dropdown-options absolute w-full left-0 rounded-xl z-10 ' + contentClassName}
                    >
                        {children(open, setOpen)}
                    </div>
                )}
            </div>
            {error && (
                <span className="text-red flex items-center text-xs mt-1">
                    <img src={exclamationIcon} alt={'exclamation point'} /> {error}
                </span>
            )}
        </label>
    );
};

export default SelectDropdown;
